import { render, staticRenderFns } from "./OperationConfigDetailCat.vue?vue&type=template&id=628f02ff&scoped=true"
import script from "./OperationConfigDetailCat.vue?vue&type=script&lang=js"
export * from "./OperationConfigDetailCat.vue?vue&type=script&lang=js"
import style0 from "./OperationConfigDetailCat.vue?vue&type=style&index=0&id=628f02ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f02ff",
  null
  
)

export default component.exports